import "dropify/dist/js/dropify"
import "dropify/dist/css/dropify.css"

export const activate = (options) => {
  $(".dropify").dropify(options)
}
